import React from 'react';

import { withAuthorization } from '../session';
import ClassificationTable from './ClassificationTable';
import ClassificationWorldCup from './ClassificationWorldCup';
import ClassificationElimination from './ClassificationElimination';

const Classification = (props) => {


    const { tournament, loading } = props;

    if (loading)
        return (
            <div className="nav justify-content-center pt-2">
                <small>Cargando...</small>
            </div>
        )

    let component = null;
    if (tournament.type === 'worldCup')
        component = <ClassificationWorldCup {...props} />
    else if (tournament.type === 'elimination')
        component = <ClassificationElimination {...props} />
    else
        component = <ClassificationTable {...props} />

    return (
        <div className="">
            {/* <div className="row justify-content-between m-0 mb-2 small">
                <span className="col-auto align-self-center font-weight-bolder m-0 p-0">
                    Clasificación
                </span>
            </div> */}

            {component}

        </div>
    )
}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin || authUser.token.premium;
    } else
        return false;
};
export default withAuthorization(condition)(Classification);